export const EmailContactIcon = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_468_4787)">
                <path
                    d="M36.0001 10.25C36.0001 8.4625 34.5151 7 32.7001 7H6.30006C4.48506 7 3.00006 8.4625 3.00006 10.25V29.75C3.00006 31.5375 4.48506 33 6.30006 33H32.7001C34.5151 33 36.0001 31.5375 36.0001 29.75V10.25ZM32.7001 10.25L19.5001 18.375L6.30006 10.25H32.7001ZM32.7001 29.75H6.30006V13.5L19.5001 21.625L32.7001 13.5V29.75Z"
                    fill="url(#paint0_linear_468_4787)"/>
            </g>
            <defs>
                <linearGradient id="paint0_linear_468_4787" x1="21.7759" y1="-7.52941" x2="53.3378" y2="55.0208"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <clipPath id="clip0_468_4787">
                    <rect width="33.3333" height="33.3333" fill="white" transform="translate(3.33331 3.33325)"/>
                </clipPath>
            </defs>
        </svg>
    );
};